export default __webpack_public_path__ + "static/media/DOG.4d6936f0.svg";